<script lang="ts">
  import { page } from '$app/stores';
  import { t } from 'svelte-i18n-lingui';

  export let category: {name: string};
</script>


<div id="top-page" class="category-title">
  {#if $page.url.searchParams.get("promo")}
    <h2 class="promo-title head-3">{$t`All our offers for ${category.name}`}</h2>
    <a class="u-btn u-btn--light" href="{$page.url.pathname}">{$t`Back to ${category.name}`}</a>
  {:else if $page.params.brand_url}
    <h2 class="head-3">{category.name}: {$t`all our products from ${$page.data.brand.page_title}`}</h2>
  {:else}
    <h2 class="head-3">{$t`All our products from ${category.name}`}</h2>
  {/if}
</div>


<style lang="scss">
  .category-title {
    display: flex;
    align-items: center;

    @media (min-width: 769px) {
      margin-bottom: 35px;
    }

    h2 {
      &.promo-title {
        margin: 15px 30px 15px 0;
      }
    }
  }
</style>
